"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Picture = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var browser_1 = require("../../utils/browser");
var lodash_1 = require("lodash");
var get_resized_image_url_1 = require("../../utils/get-resized-image-url");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var picture_scss_1 = tslib_1.__importDefault(require("./picture.scss"));
var picture_types_1 = require("./picture.types");
var memoizeMap = function (func) {
    var memoizedFunc = (0, lodash_1.memoize)(func, function (_a) {
        var url = _a.url, min = _a.min, max = _a.max, width = _a.width, height = _a.height;
        return [url, min, max, width, height].join('-');
    });
    memoizedFunc.cache = new Map();
    return memoizedFunc;
};
var Picture = /** @class */ (function (_super) {
    tslib_1.__extends(Picture, _super);
    function Picture(props) {
        var _this = _super.call(this, props) || this;
        _this.getBreakpointSource = memoizeMap(function (_a) {
            var url = _a.url, min = _a.min, max = _a.max, width = _a.width, height = _a.height;
            var src = (0, get_resized_image_url_1.getResizedImageUrl)({
                url: url,
                width: width,
                height: height,
            });
            var media = '';
            if ((0, lodash_1.isNumber)(min)) {
                media += "(min-width: ".concat(min, "px)");
            }
            if ((0, lodash_1.isNumber)(max)) {
                if (media) {
                    media += ' and ';
                }
                media += "(max-width: ".concat(max, "px)");
            }
            return { media: media, src: src };
        });
        _this.state = {
            isIE: false,
            isClient: false,
        };
        return _this;
    }
    Picture.prototype.componentDidMount = function () {
        this.setState({
            isIE: (0, browser_1.isInternetExplorer)(),
            isClient: true,
        });
    };
    Picture.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, src = _b.src, breakpoints = _b.breakpoints, dataHook = _b.dataHook, children = _b.children, className = _b.className, alt = _b.alt, mode = _b.mode, withFallbackColor = _b.withFallbackColor;
        var _c = this.state, isIE = _c.isIE, isClient = _c.isClient;
        var orderedBreakpoints = (0, lodash_1.orderBy)(breakpoints, function (_a) {
            var width = _a.width, height = _a.height;
            return width * height;
        });
        var sources = orderedBreakpoints.map(function (breakpoint) {
            return _this.getBreakpointSource(tslib_1.__assign({ url: src }, breakpoint));
        });
        // IE does not support object-fit css property, so we fallback to backgroundImage.
        // But we still render img tag for SEO
        var fallbackToBackgroundImage = isIE && mode === picture_types_1.PictureMode.COVER;
        var defaultSrc = fallbackToBackgroundImage
            ? sources[sources.length - 1].src
            : sources[0].src;
        var style = {
            backgroundImage: "url(".concat(defaultSrc, ")"),
        };
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(picture_scss_1.default.pictureContainer, className, (_a = {},
                _a[picture_scss_1.default.contain] = mode === picture_types_1.PictureMode.CONTAIN,
                _a[picture_scss_1.default.cover] = mode === picture_types_1.PictureMode.COVER,
                _a[picture_scss_1.default.fitToWidth] = mode === picture_types_1.PictureMode.FIT_TO_WIDTH,
                _a[picture_scss_1.default.fitToHeight] = mode === picture_types_1.PictureMode.FIT_TO_HEIGHT,
                _a[picture_scss_1.default.withFallbackColor] = withFallbackColor,
                _a)), "data-hook": dataHook, style: style },
            react_1.default.createElement("picture", { className: picture_scss_1.default.picture, key: isClient ? 'client' : undefined },
                sources.map(function (source, index) {
                    return source.src ? (react_1.default.createElement("source", { media: source.media, srcSet: source.src, key: index })) : null;
                }),
                defaultSrc && (react_1.default.createElement("img", { alt: alt, className: picture_scss_1.default.img, src: defaultSrc }))),
            fallbackToBackgroundImage && (react_1.default.createElement("div", { className: picture_scss_1.default.backgroundImage, style: style, "data-hook": "picture-background-image" })),
            react_1.default.createElement("div", { className: picture_scss_1.default.content }, children)));
    };
    Picture.propTypes = {
        alt: prop_types_1.default.string,
        breakpoints: prop_types_1.default.array,
        children: prop_types_1.default.node,
        className: prop_types_1.default.string,
        dataHook: prop_types_1.default.string,
        src: prop_types_1.default.string.isRequired,
        mode: prop_types_1.default.oneOf([
            picture_types_1.PictureMode.CONTAIN,
            picture_types_1.PictureMode.COVER,
            picture_types_1.PictureMode.FIT_TO_HEIGHT,
            picture_types_1.PictureMode.FIT_TO_WIDTH,
        ]),
        withFallbackColor: prop_types_1.default.bool,
    };
    Picture.defaultProps = {
        mode: picture_types_1.PictureMode.COVER,
        breakpoints: [
            {
                min: 0,
                width: 320,
                height: 180,
            },
        ],
    };
    return Picture;
}(react_1.default.Component));
exports.Picture = Picture;
//# sourceMappingURL=picture.js.map